import { default as ForgottenPasswordImpl } from "../common/components/ForgottenPassword";

export const ForgottenPassword = () => <div className="w-100 h-100" style={{ backgroundColor: '#166B7F'}}>
    <ForgottenPasswordImpl></ForgottenPasswordImpl>
</div>